<template>
  <div class="interns-wrapper text-left">
    <!-- Page back controls -->
    <GoBackButton />

    <!-- If no candidates -->
    <div
      v-if="noCandidate"
      class="bg-card"
    >
      {{ $t('pages.offer-intern.no-candidates') }}
    </div>

    <!-- Candidate info -->
    <div
      v-else
      class="text-left"
    >
      <RejectedInterns ref="rejectedInterns" />
      <InternControl
        :offer-apply="candidateApplication"
        @getNewCandidate="getApplication(true)"
      />
      <hr>
      <UserData :user="candidateApplication.user" />
      <Educations
        v-if="candidateApplication.user && candidateApplication.user.cv && candidateApplication.user.cv.educations"
        :educations="candidateApplication.user.cv.educations"
      />
      <Experience
        v-if="candidateApplication.user && candidateApplication.user.cv && candidateApplication.user.cv.experience"
        :experience="candidateApplication.user.cv.experience"
      />
      <Languages
        v-if="candidateApplication.user && candidateApplication.user.cv && candidateApplication.user.cv.languages"
        :languages="candidateApplication.user.cv.languages"
      />
      <TextCv
        v-if="candidateApplication.user && candidateApplication.user.cv && candidateApplication.user.cv.text_cv"
        :text-cv="candidateApplication.user.cv.text_cv"
      />
      <Employment
        v-if="candidateApplication.user && candidateApplication.user.cv && candidateApplication.user.cv.levels"
        :levels="candidateApplication.user.cv.levels"
        :experience-time="candidateApplication.user.cv.experienceTime"
        :categories="candidateApplication.user.cv.categories"
        :industries="candidateApplication.user.cv.industries"
        :contracts="candidateApplication.user.cv.contracts"
      />
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import InternControl from '@/components/jobs/employer/InternControl';
import Educations from '@/components/jobs/CV/Educations';
import Experience from '@/components/jobs/CV/Experience';
import Languages from '@/components/jobs/CV/Languages';
import TextCv from '@/components/jobs/CV/TextCv';
import Employment from '@/components/jobs/CV/Employment';
import UserData from '@/components/jobs/CV/UserData';
import RejectedInterns from '@/components/jobs/CV/RejectedInterns';

export default {
  components: {
    GoBackButton,
    InternControl,
    Educations,
    Experience,
    Languages,
    TextCv,
    Employment,
    UserData,
    RejectedInterns
  },
  data() {
    return {
      candidateApplication: null,
      noCandidate: true,
    }
  },
  mounted() {
    this.getApplication();
  },
  methods: {
    getApplication(isUpdate = false) {
      this.axios.get('/offerApply/intern/' + this.$route.query.offer)
        .then(response => {
          this.noCandidate = Object.keys(response.data).length === 0;
          this.candidateApplication = response.data;
        })
        .catch(() => {
            this.noCandidate = true;
        });

        if(isUpdate) {
          this.$refs.rejectedInterns.rejectedInternsCount += 1;
        }
    }
  }
}
</script>

<style scoped>
  .interns-wrapper {
    width: 70%;
    margin: auto;
  }
</style>
